export const contactsData = {
    email: 'satheeshraj333@gmail.com',
    phone: '+91 9444470709',
    address: 'Coimbatore, India ',

    sheetAPI: ''
}